export const FETCH_PATIENT_PROFILE = 'FETCH_PATIENT_PROFILE';
export const PATIENT_LOADER = 'PATIENT_LOADER';
export const RESET_PATIENT = 'RESET_PATIENT';
export const GET_MASTER_ORDERS = 'GET_MASTER_ORDERS';
export const FILTER_ORDER_TYPES = 'FILTER_ORDER_TYPES';
export const FILTER_ORDER_TYPE_OPTIONS = 'FILTER_ORDER_TYPE_OPTIONS';
export const GET_PATIENT_APPOINTMENTS = 'GET_PATIENT_APPOINTMENTS';
export const FETCH_ENCOUNTER_FORMS = 'FETCH_ENCOUNTER_FORMS';
export const PUT_PATIENT_APPOINTMENT_FORM_STATUS =
  'PUT_PATIENT_APPOINTMENT_FORM_STATUS';
export const PUT_PATIENT_SURVEY_FORM_STATUS = 'PUT_PATIENT_SURVEY_FORM_STATUS';
export const RESET_ORDER_CATEGORY = 'RESET_ORDER_CATEGORY';
export const RESET_ORDER_TYPE = 'RESET_ORDER_TYPE';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_ERROR = 'CREATE_ORDER_ERROR';
export const CREATE_ORDER_ERROR_RESET = 'CREATE_ORDER_ERROR_RESET';
export const PUT_APPOINTMENT_PATIENT = 'PUT_APPOINTMENT_PATIENT';
export const PUT_LOADER = 'PUT_LOADER';
export const PATIENT_RESET = 'PATIENT_RESET';
export const POST_ENCOUNTER_FORM_SUCCESS = 'POST_ENCOUNTER_FORM_SUCCESS';
export const POST_ENCOUNTER_FORM_ERROR = 'POST_ENCOUNTER_FORM_ERROR';
export const FETCH_ENCOUNTER_BY_ID = 'FETCH_ENCOUNTER_BY_ID';
export const RESET_FORM = 'RESET_FORM';
export const UPDATE_ENCOUNTER_FORM_BY_ID_SUCCESS =
  'UPDATE_ENCOUNTER_FORM_BY_ID_SUCCESS';
export const UPDATE_ENCOUNTER_FORM_BY_ID_ERROR =
  'UPDATE_ENCOUNTER_FORM_BY_ID_ERROR';
export const UPDATE_ENCOUNTER_FORM_BY_ID = 'UPDATE_ENCOUNTER_FORM_BY_ID';
export const ESIGN_ENCOUNTER_NOTE = 'ESIGN_ENCOUNTER_NOTE';
export const FETCH_PATIENT_FORMS_DETAILS = 'FETCH_PATIENT_FORMS_DETAILS';
export const PUT_PATIENT_FORMS_STATUS = 'PUT_PATIENT_FORMS_STATUS';
export const FETCH_PATIENT_TASKS = 'FETCH_PATIENT_TASKS';
export const FETCH_PATIENT_COMPLETED_TASKS = 'FETCH_PATIENT_COMPLETED_TASKS';
export const RESET_PATIENT_TASKS = 'RESET_PATIENT_TASKS';
export const PUT_PATIENT_TASK_STATUS = 'PUT_PATIENT_TASK_STATUS';
export const FETCH_PATIENT_ORDERS = 'FETCH_PATIENT_ORDERS';
export const FETCH_PATIENT_ARTICLES = 'FETCH_PATIENT_ARTICLES';
export const FETCH_PROVIDER_SUBSCRIPTIONS = 'FETCH_PROVIDER_SUBSCRIPTIONS';
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_ERROR = 'CREATE_PATIENT_ERROR';
export const PATIENT_ERROR_RESET = 'PATIENT_ERROR_RESET';
export const UPLOAD_ENCOUNTER_ATTACHMENTS = 'UPLOAD_ENCOUNTER_ATTACHMENTS';
export const CLEAR_ENCOUNTER_ATTACHMENTS = 'CLEAR_ENCOUNTER_ATTACHMENTS';
export const FETCH_PATIENT_SECURE_FILES = 'FETCH_PATIENT_SECURE_FILES';
export const PUT_PATIENT_APPOINTMENT_STATUS = 'PUT_PATIENT_APPOINTMENT_STATUS';
export const UPDATE_PATIENT_APPOINTMENT_FORMS =
  'UPDATE_PATIENT_APPOINTMENT_FORMS';
export const EDITING_PATIENT_PROFILE = 'EDITING_PATIENT_PROFILE';
export const CLOSE_PATIENT_PROFILE_EDITING = 'CLOSE_PATIENT_PROFILE_EDITING';
export const RESCHEDULE_PATIENT_APPOINTMENT = 'RESCHEDULE_PATIENT_APPOINTMENT';
export const UPDATE_PATIENT_PROFILE = 'UPDATE_PATIENT_PROFILE';

export const FETCH_ENCOUNTER_NOTE = 'FETCH_ENCOUNTER_NOTE';
export const FETCH_ENCOUNTER_NOTE_ACTION = 'FETCH_ENCOUNTER_NOTE_ACTION';
